import { render, staticRenderFns } from "./ReleaseMainlandCloud.vue?vue&type=template&id=6c2e1c8b&scoped=true"
import script from "./ReleaseMainlandCloud.vue?vue&type=script&lang=js"
export * from "./ReleaseMainlandCloud.vue?vue&type=script&lang=js"
import style0 from "./ReleaseMainlandCloud.vue?vue&type=style&index=0&id=6c2e1c8b&prod&scoped=true&lang=css"
import style1 from "./ReleaseMainlandCloud.vue?vue&type=style&index=1&id=6c2e1c8b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2e1c8b",
  null
  
)

export default component.exports